<app-header></app-header>

<router-outlet></router-outlet>

<app-footer></app-footer>

<button (click)="scrollToTop()" class="scrolltop-btn" id="scrollTopBtn" title="Go to top">
    <i class="sprite-img-header-footer red-arrow-top"></i>
</button>
